import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Grid,
  Button,
  IconButton,
  Typography,
  Box,
  Chip,
  Alert,
  Snackbar,
  Slide,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { grey } from "@mui/material/colors";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import Notify from "../../../Notify";

// COMPONENTES
import DatosRep from "./DatosRep";
import SalidaReparto from "./SalidaReparto";
import LlegadaReparto from "./LlegadaReparto";
import Modalagregarpedidos from "./Modalagregarpedidos";
// import FileUploadViajes from "./FileUploadViajes";
import UploadFiles2 from "../../../../services/UploadFiles2";
import ModalMapa from "./ModalMapa";

// ICONOS
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";

export default function Verrepartos4(props) {
  const [viajesGruas, setViajesGruas] = useState([]);
  const [salida, setSalida] = useState(false);
  const [llegada, setLlegada] = useState(false);
  const [datosRep, setDatosRep] = useState({});
  const [agregarPedidos, setAgregarPedidos] = useState(false);
  const [editarFecha, setEditarFecha] = useState(false);
  const [modalMapa, setModalMapa] = useState(false);
  const [notificacion, setNotificacion] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);
  // Estado para snackbar de eliminacion del viaje
  const [successSnack, setSuccessSnack] = useState({
    open: false,
    message: "",
  });

  // ----- ESTADOS PARA EL TIMER DE ACTUALIZACIONES -----
  const [hasUpdates, setHasUpdates] = useState(false); // Controla el snackbar
  const isCheckingUpdates = useRef(false); // Evita solapamiento de fetches
  // -----------------------------------------------------

  // ADJUNTOS
  const [openCloseAdj, setOpenCloseAdj] = useState(false);
  const [newUuid, setNewUuid] = useState("");

  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
  };

  const [filtro, setFiltro] = useState(0); // 0 = Asignados, 1 = Iniciados, 2 = Finalizados

  // ----------------- OBTENER DATOS (carga inicial y manual) -----------------
  const obtenerViajesGruas = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${UrlApi}/viajes_gruas`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setViajesGruas(data);
    } catch (err) {
      console.error("Error al traer viajes:", err);
      setViajesGruas([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // --------------------------------------------------------------------------
  //  COMPARACIÓN ENTRE DOS ARRAYS DE OBJETOS (basada en id)
  // --------------------------------------------------------------------------
  const deepEqual = (a, b) => {
    if (a === b) return true;
    if (
      typeof a !== "object" ||
      a === null ||
      typeof b !== "object" ||
      b === null
    )
      return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (let key of keysA) {
      if (!keysB.includes(key)) return false;
      if (!deepEqual(a[key], b[key])) return false;
    }
    return true;
  };

  const arraysEqualById = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    const map1 = new Map(arr1.map((item) => [item.id, item]));
    const map2 = new Map(arr2.map((item) => [item.id, item]));
    if (map1.size !== map2.size) return false;
    for (let [id, obj1] of map1) {
      const obj2 = map2.get(id);
      if (!obj2) return false;
      if (!deepEqual(obj1, obj2)) return false;
    }
    return true;
  };

  // --------------------------------------------------------------------------
  //  FUNCIÓN QUE SE EJECUTA CADA MINUTO PARA DETECTAR CAMBIOS
  // --------------------------------------------------------------------------
  const checkForUpdates = useCallback(async () => {
    // Evita ejecutar si ya hay una petición en curso
    if (isCheckingUpdates.current) return;
    isCheckingUpdates.current = true;

    try {
      const res = await fetch(`${UrlApi}/viajes_gruas`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const newData = await res.json();

      // Compara con los datos actualmente mostrados en la tabla
      if (!arraysEqualById(viajesGruas, newData)) {
        setHasUpdates(true);
      }
    } catch (err) {
      console.error("Error al verificar actualizaciones:", err);
    } finally {
      isCheckingUpdates.current = false;
    }
  }, [viajesGruas]); // Se recalcula cuando cambian los datos mostrados

  // --------------------------------------------------------------------------
  //  TIMER CADA 60 SEGUNDOS
  // --------------------------------------------------------------------------
  useEffect(() => {
    const intervalId = setInterval(() => {
      checkForUpdates();
    }, 60000); // 1 minuto

    return () => clearInterval(intervalId);
  }, [checkForUpdates]);

  // --------------------------------------------------------------------------
  //  REFRESCO MANUAL (icono en el snackbar)
  // --------------------------------------------------------------------------
  const handleRefreshData = () => {
    obtenerViajesGruas();
    setHasUpdates(false); // Oculta el snackbar
  };

  // --------------------------------------------------------------------------
  //  CARGA INICIAL
  // --------------------------------------------------------------------------
  useEffect(() => {
    obtenerViajesGruas();
  }, [obtenerViajesGruas]);

  // ------------------------------------------------------------
  const handleClose = () => {
    props.setpedidosSucursales(true);
    props.setVerReparto(false);
    props.setMostrarPedidos(true);
    props.actualizar();
  };

  const columns = useMemo(
    () => [
      { header: "Viaje", accessorKey: "id", size: 70, enableHiding: false },
      { header: "Grúa", accessorKey: "patente", size: 100 },
      { header: "Chofer", accessorKey: "chofer_nombre_apellido", size: 100 },
      {
        header: "Fecha de Salida",
        accessorKey: "fecha_programada_viaje",
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value) return "-";
          const fecha = new Date(value);
          return fecha.toLocaleDateString("es-AR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        },
      },
      {
        header: "Fecha Finalización",
        accessorKey: "fecha_finalizado",
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value) return "-";
          const fecha = new Date(value);
          return fecha.toLocaleDateString("es-AR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        },
      },
      {
        header: "Estado",
        accessorKey: "estado",
        size: 70,
        enableHiding: false,
      },
    ],
    [],
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
    sorting: [
      {
        id: "fecha_programada_viaje",
        desc: true,
      },
    ],
    columnVisibility: { uuid_viaje: false },
  };

  const handleViajeEliminado = useCallback(() => {
    obtenerViajesGruas();
    setHasUpdates(false);
    setSuccessSnack({
      open: true,
      message: "El viaje fue eliminado porque ya no tiene reclamos.",
    });
  }, [obtenerViajesGruas]);

  //***********************************************************************/
  const pal = {
    active: ["#ffffff", "#f9f9f9"],
    hover: "#f5f5f5",
  };

  const getEstadoBorderColor = (idEstado) => {
    switch (idEstado) {
      case 343:
        return "#1976D2";
      case 345:
        return "#2E7D32";
      default:
        return "transparent";
    }
  };

  const getRowColorByEstado = (idEstado) => {
    switch (idEstado) {
      case 343:
        return {
          bgColor: "#F0F7FF",
          hoverColor: "#E1F0FF",
        };
      case 345:
        return {
          bgColor: "#F0FFF4",
          hoverColor: "#E1F7E8",
        };
      default:
        return {
          bgColor: null,
          hoverColor: "#F5F5F5",
        };
    }
  };

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default: "rgb(234, 239, 241)",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme],
  );

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Box sx={{ flexGrow: 1, mt: 0.8 }}>
        <Grid container backgroundColor="#1F618D" p={2} alignItems="center">
          <Grid item xs={2}>
            <IconButton onClick={handleClose}>
              <ArrowBackIcon sx={{ color: grey[50] }} />
            </IconButton>
          </Grid>
          <Grid item xs={8} container justifyContent="center">
            <Typography variant="h5" color="#ffffff">
              Repartos de Grúa Asignados
            </Typography>
          </Grid>
          <Grid item xs={2} />
        </Grid>
      </Box>

      {/* ----------------- SNACKBAR DE ACTUALIZACIONES ----------------- */}
      <Snackbar
        open={hasUpdates}
        autoHideDuration={null}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ mt: 2, zIndex: 9999 }}
        TransitionComponent={Slide}
        transitionDuration={500}
        TransitionProps={{ direction: "down" }}
      >
        <Alert
          severity="warning"
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#FFF3E0",
            color: "#BF5E00",
            borderColor: "#ED6C02",
            borderLeftWidth: 6,
            borderLeftColor: "#ED6C02",
            boxShadow: 4,
            "& .MuiAlert-message": {
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            },
            "& .MuiAlert-icon": {
              color: "#ED6C02",
            },
          }}
          action={
            <Button
              variant="outlined"
              size="small"
              onClick={handleRefreshData}
              startIcon={<RefreshIcon />}
              sx={{
                fontWeight: "bold",
                whiteSpace: "nowrap",
                ml: 2,
                mb: 0.5,
                color: "#ED6C02",
                borderColor: "#ED6C02",
                backgroundColor: "white",
                "&:hover": {
                  backgroundColor: "#FFE8D6",
                  borderColor: "#BF5E00",
                },
              }}
            >
              ACTUALIZAR
            </Button>
          }
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: 500, color: "#BF5E00" }}
          >
            Se han detectado cambios en los viajes
          </Typography>
        </Alert>
      </Snackbar>
      {/* -------------------------------------------------------------------------- */}
      {/* SNACKBAR para eliminación del viaje */}
      <Snackbar
        open={successSnack.open}
        autoHideDuration={4000}
        onClose={() => setSuccessSnack({ ...successSnack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="success"
          variant="filled"
          onClose={() => setSuccessSnack({ ...successSnack, open: false })}
        >
          {successSnack.message}
        </Alert>
      </Snackbar>

      {/* -------------------------------------------------------------------------- */}

      {viajesGruas && (
        <>
          <ThemeProvider theme={tableTheme}>
            <MaterialReactTable
              enableColumnResizing
              columns={columns}
              data={viajesGruas}
              enablePagination={true}
              enableBottomToolbar={true}
              initialState={initialState}
              state={{
                isLoading: loading,
              }}
              positionActionsColumn="last"
              muiTableHeadCellProps={tableHeadCellProps}
              localization={MRT_Localization_ES}
              enableToolbarInternalActions={true}
              renderTopToolbar={({ table }) => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  {table.getState().grouping.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexWrap: "wrap",
                        p: 1,
                        bgcolor: "grey.50",
                        borderRadius: 1,
                        border: "1px solid",
                        borderColor: "grey.300",
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        Agrupado por:
                      </Typography>
                      {table.getState().grouping.map((columnId) => {
                        const column = table.getColumn(columnId);
                        return (
                          <Chip
                            key={columnId}
                            label={column.columnDef.header}
                            onDelete={() =>
                              table.getColumn(columnId).toggleGrouping()
                            }
                            size="small"
                            sx={{ mr: 0.5 }}
                          />
                        );
                      })}
                      {table.getState().grouping.length > 0 && (
                        <Button
                          size="small"
                          onClick={() => table.resetGrouping()}
                          startIcon={<ClearIcon />}
                          sx={{ ml: "auto" }}
                        >
                          Limpiar Agrupación
                        </Button>
                      )}
                    </Box>
                  )}
                </Box>
              )}
              displayColumnDefOptions={{
                "mrt-row-expand": {
                  enableGrouping: false,
                },
                "mrt-row-actions": {
                  enableGrouping: false,
                },
              }}
              muiTableBodyCellProps={({ row, column }) => {
                const value = row.original?.[column.id];
                const isNumber = typeof value === "number" && !isNaN(value);
                return {
                  align: isNumber ? "right" : "left",
                  sx: {
                    backgroundColor: "transparent",
                    color: "black",
                    borderColor: "black",
                  },
                };
              }}
              muiTableBodyRowProps={({ table, row }) => {
                const rowIndex = table
                  .getRowModel()
                  .rows.findIndex((r) => r.id === row.id);
                const idEstado =
                  row.original?.id_estado ||
                  row.original?.estado?.id ||
                  row.original?.estado_id;
                const estadoColors = getRowColorByEstado(idEstado);
                const bgColor =
                  estadoColors.bgColor || pal.active[rowIndex % 2];
                const hoverBgColor = estadoColors.hoverColor || pal.hover;

                return {
                  hover: false,
                  sx: {
                    backgroundColor: bgColor,
                    color: "black",
                    borderColor: "transparent",
                    transition:
                      "background-color 0.18s ease-in-out, transform 0.15s ease",
                    "& .MuiTableCell-root": {
                      borderBottom: "1px solid rgba(0,0,0,0.06)",
                    },
                    "&:hover": {
                      backgroundColor: hoverBgColor,
                      transform: "translateY(-1px)",
                    },
                    borderLeft: idEstado
                      ? `3px solid ${getEstadoBorderColor(idEstado)}`
                      : "none",
                  },
                };
              }}
              enableColumnActions={false}
              enableDensityToggle={false}
              layoutMode="semantic"
              renderDetailPanel={({ row }) => (
                <Box>
                  <DatosRep
                    datos={row.original}
                    filtro={filtro}
                    onViajeEliminado={handleViajeEliminado}
                  />
                </Box>
              )}
              enableExpandAll={true}
              enableGrouping={true}
              enableColumnOrdering={true}
              enableColumnFilters={true}
              enableColumnDragging={true}
              enableHiding={true}
              positionExpandColumn="first"
              enableStickyFooter
              enableFullScreenToggle={false}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enableStickyHeader
            />
          </ThemeProvider>
        </>
      )}

      {openCloseAdj ? (
        <UploadFiles2
          fileId={newUuid}
          openclose={true}
          mostrar={true}
          onClose={() => handleOpenCloseAdj(false)}
          title="Adjuntos del Viaje"
          logConfig={{
            accionGuardar: "Guardar adjunto viaje",
            accionBorrar: "Borrar adjunto viaje",
            modulo: "Repartos_Gruas",
            descripcion: "Gestión de adjuntos del viaje",
          }}
        />
      ) : null}
      {modalMapa ? (
        <ModalMapa datos={datosRep} open={modalMapa} setOpen={setModalMapa} />
      ) : null}
      {salida ? <SalidaReparto open={setSalida} datos={datosRep} /> : null}
      {llegada ? <LlegadaReparto open={setLlegada} datos={datosRep} /> : null}
      {agregarPedidos ? (
        <Modalagregarpedidos open={setAgregarPedidos} datos={datosRep} />
      ) : null}

      {notificacion ? (
        <Notify
          mensaje={mensaje}
          open={openSnack}
          color={"#D4EFDF"}
          severity={"success"}
          handleClose={() => setEditarFecha(false)}
        />
      ) : null}
    </div>
  );
}
